<template>
  <section class="container section pt-0">
    <functions-datatable />
  </section>
</template>

<script>
import FunctionsDatatable from "./functions_datatable/Index.vue";

export default {
  name: "Functions",
  components: { FunctionsDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
